import { render, staticRenderFns } from "./ConfigStoreDia.vue?vue&type=template&id=dd5a3142&scoped=true"
import script from "./ConfigStoreDia.vue?vue&type=script&lang=js"
export * from "./ConfigStoreDia.vue?vue&type=script&lang=js"
import style0 from "./ConfigStoreDia.vue?vue&type=style&index=0&id=dd5a3142&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5a3142",
  null
  
)

export default component.exports